export default {
  delete: {
    title: '提示',
    content: '是否确认删除',
  },
  indexTable: {
    date: '日期',
    id: 'id',
    name: '名称',
    size: '大小',
    status: '状态',
    loadingStatus: '加载进度',
    conditionSelected: '已选条件',
    operation: '操作',
    delete: '删除',
    batchDeletion: '批量删除',
  },
  modal: {
    title: '回显屏蔽商城',
    text: '您回显商城条件中存在以下屏蔽商城，是否继续导出',
    allDel: '全部移除',
    shop: '商城名称',
    action: '操作',
    del: '移除',
  },
};
